/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Negotiation_Loading_AriaInputs */

const en_negotiation_loading_aria = /** @type {(inputs: Negotiation_Loading_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading negotiation framework`)
};

const de_negotiation_loading_aria = /** @type {(inputs: Negotiation_Loading_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading negotiation framework`)
};

const fr_negotiation_loading_aria = /** @type {(inputs: Negotiation_Loading_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading negotiation framework`)
};

const es_negotiation_loading_aria = /** @type {(inputs: Negotiation_Loading_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading negotiation framework`)
};

const it_negotiation_loading_aria = /** @type {(inputs: Negotiation_Loading_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading negotiation framework`)
};

const nl_negotiation_loading_aria = /** @type {(inputs: Negotiation_Loading_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading negotiation framework`)
};

const pl_negotiation_loading_aria = /** @type {(inputs: Negotiation_Loading_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading negotiation framework`)
};

const fi_negotiation_loading_aria = /** @type {(inputs: Negotiation_Loading_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading negotiation framework`)
};

const da_negotiation_loading_aria = /** @type {(inputs: Negotiation_Loading_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading negotiation framework`)
};

const sv_negotiation_loading_aria = /** @type {(inputs: Negotiation_Loading_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading negotiation framework`)
};

/**
* | output |
* | --- |
* | "Loading negotiation framework" |
*
* @param {Negotiation_Loading_AriaInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const negotiation_loading_aria = /** @type {((inputs?: Negotiation_Loading_AriaInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Negotiation_Loading_AriaInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_negotiation_loading_aria(inputs)
	if (locale === "fr") return fr_negotiation_loading_aria(inputs)
	if (locale === "es") return es_negotiation_loading_aria(inputs)
	if (locale === "it") return it_negotiation_loading_aria(inputs)
	if (locale === "nl") return nl_negotiation_loading_aria(inputs)
	if (locale === "pl") return pl_negotiation_loading_aria(inputs)
	if (locale === "fi") return fi_negotiation_loading_aria(inputs)
	if (locale === "da") return da_negotiation_loading_aria(inputs)
	if (locale === "sv") return sv_negotiation_loading_aria(inputs)
	return en_negotiation_loading_aria(inputs)
});